<template>
  <router-view />
</template>

<script>
import { procedureResource } from '@/resources/procedure.resource';
import { procedureRoute } from '@/router/mainRoute/procedure.route';
import { tryParseInt } from '@/utils/number';

// @vuese
// Kontener procedur
// Wyświetla przekazany widok jak `@\components\appLayout\Router.vue`
// Dodatkowo aktualizuje breadcrumb, dzięki czemu możemy wrócić do dokumentu nadrzędnego
// @group Procedure
export default {
  beforeRouteEnter(to, from, next) {
    updateBreadcrumb(to, next);
  },
  beforeRouteUpdate(to, from, next) {
    updateBreadcrumb(to, next);
  }
};

function updateBreadcrumb(to, next) {
  const originalCrumb = { title: 'Lista procedur', name: 'procedureList' };

  if (to.query.parentId && to.query.parentProcedureId) {
    return procedureResource.get(tryParseInt(to.query.parentProcedureId)).then(parentProcedure => {
      procedureRoute.meta.breadcrumb = [
        { ...originalCrumb, query: { parentId: undefined, parentProcedureId: undefined } },
        {
          title: parentProcedure.name,
          name: 'procedureView',
          query: { parentId: undefined, parentProcedureId: undefined },
          params: { procedureId: to.query.parentProcedureId }
        },
        {
          title: 'Informacje o wniosku',
          name: 'documentView',
          params: { procedureId: to.query.parentProcedureId, documentId: to.query.parentId },
          query: { parentId: undefined, parentProcedureId: undefined }
        }
      ];
      next();
    });
  } else {
    procedureRoute.meta.breadcrumb = originalCrumb;
  }
  next();
}
</script>
